import type { CreateInvitationPayload, InitialInvitationValues, InviteesRef } from '../Invitations.types';

export function composeInvitations(
  inviteesFormRef: InviteesRef,
  invitationDetails: InitialInvitationValues['invitationDetails'],
): Array<CreateInvitationPayload> {
  const composedInvitations: Array<CreateInvitationPayload> = [];

  const inviteeForms = inviteesFormRef.current ? Object.values(inviteesFormRef.current.getForms()) : [];

  inviteeForms.forEach((invitee) => {
    const { errors, values } = invitee.validateAndTransform();
    if (!errors) {
      const composedInvite: CreateInvitationPayload = {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        mobile: values.mobile,
        expiry: invitationDetails.expiry,
        company: invitationDetails.company?.trim(),
        subject: invitationDetails.subject?.trim(),
        visitorNotes: invitationDetails.visitorNotes?.trim(),
        adminNotes: invitationDetails.adminNotes?.trim(),
        visitorType: invitationDetails.visitorTypeOption.value,
        startDate: invitationDetails.validFrom,
        endDate: invitationDetails.validTo,
        siteId: invitationDetails.siteOption.value,
        hostId: invitationDetails.hostOption?.value,
        zoneId: invitationDetails.zone?.value,
      };

      composedInvitations.push(composedInvite);
    }
  });

  return composedInvitations;
}
